// import { RobotEnvConfig } from "./api/data-interfaces";
import { useEffect, useRef, useState } from "react";
import ThreeDScene from "./ThreeDScene";
import WsManagement from "../api/WsManagement";
import CalloutOverlay from "./threeDComponents/CalloutOverlay";


export default function Renderer3D({
  height,
  wsManagement,
  // comps,
  setSceneCallback,
}: {
  wsManagement: WsManagement;
  height: string;
  setSceneCallback: (scene: ThreeDScene) => void;
}) {
  const divRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<ThreeDScene | null>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      if (divRef.current) {
        setDimensions({
          width: divRef.current.clientWidth,
          height: divRef.current.clientHeight,
        });
      }
    };

    updateDimensions();

    // Initialize the ResizeObserver
    const observer = new ResizeObserver(() => {
      updateDimensions();
    });

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, []);


  useEffect(() => {
    if (!divRef.current || !wsManagement) {
      return;
    }
    const div = divRef.current;
    if (!sceneRef.current) {
      const scene = new ThreeDScene(div);

      // console.log("CREATING NEW SCENE");
      // const scene = new ThreeDScene(div);
      const uiService = wsManagement.uiService;
      sceneRef.current = scene;
      uiService.clearComponents();
      const loader = async () => {
        // for (const comp of compRefs.current) {
        //   await uiService.loadComponent(comp, scene);
        // }
        uiService.updateUIState({
          addObjectActions: uiService.addObjectActions,
          environmentActions: uiService.environmentActions,
          // floorTextureActions: uiService.floorTextureActions,
        });
        setSceneCallback(scene);
      };
      loader()
        .then(() => {
          console.log("All components loaded");
        })
        .catch((err) => {
          console.error("Error loading components", err);
        });
    }

  }, [wsManagement]);

  return (

    <div style={{ position: "relative", width: "100%", height }}>
      <div ref={divRef} style={{
        width: "100%",
        height,
        overflow: "hidden",
        padding: 0,
        margin: 0,
      }} tabIndex={0} />
      {sceneRef.current && divRef.current && (
        <CalloutOverlay
          actors={sceneRef.current.actors ?? []}
          camera={sceneRef.current.camera}
          width={divRef.current.clientWidth}
          height={divRef.current.clientHeight}
        />
      )}
    </div>
  );
}